module.exports = __webpack_public_path__ + "static/media/116.4ccb951c.jpg";